<template>
  <div class="timer" :class="{'timer-none': isSingle}">
    <i class="timer-ico"></i>
    <span> {{ formattedTimeLeft }} </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timePassed: 0,
      timerInterval: null,
      showMsg:true,
      showGameOver:true,
      stopTime:false,
      lifeDown:0,
      isSingle: false,
    };
  },
  props:{
    timeLimit:{
      type: Number,
    },
    timeWrong:{
      type: Number,
    },
    stop:{
      type: Boolean,
    }

  },
  computed: {
    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      const minutes = Math.floor(timeLeft / 60);
      let seconds = timeLeft % 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      return `${minutes}:${seconds}`;
    },
    timeLeft() {
      return this.timeLimit - this.timePassed;
    },
  },
  watch: {
    stop(){
      if (this.stop){
        clearInterval(this.timerInterval);
      }else{
        this.stop = false;
        this.startTimer();
      }
    },
    timeLeft(newValue) {
      if (this.timeLeft === this.timeWrong) {
        this.$emit('showMessage', this.showMsg)
        let soundDictionaryAllert = new Howl({
          src: [require('@/assets/audio/bankoslowka/do_slowniczka/BNP_Samodzielniak_6_B_1.mp3')]
        });
        soundDictionaryAllert.play();
      }
      if (newValue === 0) {
        this.onTimesUp();
        this.$emit('gameOver', this.showGameOver)
        this.$emit('lifeDown', this.lifeDown--)
        var sounds = [
          "end_1.mp3",
          "end_2.mp3"
        ];
        var randSounds = sounds[Math.floor(Math.random() * sounds.length)];
        let endTimeAudio = new Howl({
          src: [require('@/assets/audio/bankoslowka/koniec_gry/'+ randSounds)]
        });
        endTimeAudio.play();
        this.timePassed = 0;
        this.startTimer();
      }
    }
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    onTimesUp() {
      clearInterval(this.timerInterval);
    },
    startTimer() {
      this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
    },

  }
};
</script>
